import { Location } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SpinnerHelper } from '../../../../helpers/spinner.helper';
import { ToastrHelper } from '../../../../helpers/toastr.helper';
import { Project } from '../../../../models/projects/project.model';
import { ProjectsService } from '../../../../services/projects/projects.service';

@Component({
    selector: 'dialog-close-project',
    templateUrl: './dialog-close-project.component.html',
    styleUrls: ['./dialog-close-project.component.scss'],
})
export class DialogCloseProjectComponent {
    public currentRate: number = 5;
    @Input() public project: Project;
    public rateModalVisible: boolean;
    @Input() public visible = false;
    @Output() public visibleChange = new EventEmitter<boolean>();

    constructor(
        private projectsService: ProjectsService,
        private location: Location,
        private spinnerHelper: SpinnerHelper,
        private toastrHelper: ToastrHelper,
        private translate: TranslateService,
    ) {}

    public closeModal() {
        this.visible = false;
        this.visibleChange.emit(false);
    }

    public closeRateModal() {
        this.rateModalVisible = false;
        this.visible = true;
    }

    public closeThisProject() {
        this.spinnerHelper.showSpinner();
        this.projectsService.closeProject(this.project.id, this.currentRate).subscribe(
            () => {
                const msg = this.translate.instant('projects.projectDetails.toast.projectClosed');
                this.toastrHelper.showSuccess(msg);
                this.location.back();
            },
            (error) => {
                this.toastrHelper.showGenericError(error);
            },
            () => {
                this.spinnerHelper.hideSpinner();
                this.rateModalVisible = false;
                this.visibleChange.emit(false);
            },
        );
    }

    public showRateModal() {
        this.visible = false;
        this.rateModalVisible = true;
    }
}
